import { getZoneColors } from '../constants';
import { IStation } from '../ts/interface/station.interface';

export const stationConfigurations = {
  ZONE: 'zone',
  RACK: 'rack',
  DOCK: 'dock',
  STORE: 'store',
  WAREHOUSE: 'warehouse',
};

// Locations that track how many racks/lockers they have ("Number of Racks" in details)
export const showLocationCapacity = (configuration: string, currentMode?: string) =>
  configuration === stationConfigurations.RACK ||
  configuration === stationConfigurations.WAREHOUSE ||
  currentMode === 'bike_locker' ||
  currentMode === 'bikeshare(keybox)' ||
  currentMode === 'bikeRoom';

export const getCapacityUnitsName = (currentMode?: string) =>
  currentMode === 'bike_locker' ? 'Lockers' : 'Racks';

export const showRadious = (location: IStation) => {
  return location.radius && location.radius > 0;
};

export const getLocationColors = (location: IStation) => {
  return getZoneColors(location.zone_type);
};
